module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "pg-boilerplate",
    attrs: {
      "id": "pg-header",
      "lang": "en"
    }
  }, [_c('div', {
    staticClass: "page",
    attrs: {
      "id": "calibre_pb_0"
    }
  }, [_c('div', {
    staticClass: "calibre4"
  }, [_c('div', {
    staticClass: "calibre5"
  }, [_c('table', {
    staticClass: "tcenter",
    attrs: {
      "id": "toc"
    }
  }, [_c('thead', {
    staticClass: "calibre6"
  }, [_c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "calibre8",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("CONTENTS")])])]), _vm._v(" "), _c('tbody', {
    staticClass: "calibre9"
  }, [_c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("I.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section002#chI"
    }
  }, [_vm._v("Wedding Night")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("II.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('a', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section003#chII"
    }
  }, [_vm._v("“Hanging is Too Good⸺”")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("III.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section004#chIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The New Sheriff")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("IV.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section005#chIV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Range Funeral")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("V.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section006#chV",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hashknife and Sleepy")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("VI.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section007#chVI",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Hashknife Smells a Rat")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("VII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section008#chVII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("City "), _c('i', {
    staticClass: "calibre10"
  }, [_vm._v("v.")]), _vm._v(" Range")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("VIII.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section009#chVIII",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Clues")])])]), _vm._v(" "), _c('tr', {
    staticClass: "calibre7"
  }, [_c('td', {
    staticClass: "tdc"
  }, [_vm._v("IX.")]), _vm._v(" "), _c('td', {
    staticClass: "tdc1"
  }, [_c('span', {
    staticClass: "pginternal",
    attrs: {
      "href": "#/OEBPS/Text/Section010#chIX",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("The Inquest")])])])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-aa41086e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/Text/Section001_0001.vue
// module id = 66
// module chunks = 0